export default __webpack_public_path__ + "188916aa973a3d17523bddb65db2e0f3.jpg";